<template>
  <div class="white-board-container">
    <div class="text">
      <div v-if="isCityWithoutHouse">
        {{ $t('PERKS_VENUE_CITIES_WITHOUT_HOUSES') }} -
        <span>{{ fields.venueName.value }}</span>
      </div>
      <div v-else>
        <div>{{ $t(`REGION_LABEL_${convertName}`) }}</div>
      </div>
    </div>
    <sc-text class="title" tag="h1" :field="fields.perksTitle"/>
    <sc-rich-text tag="div" class="description rich-text-block" :field="fields.shortDescription"/>
    <div v-if="isEditMode">
      <sc-text class="promotion-code" :field="fields.promotionCode"/>
    </div>
    <copy-to-clipboard-button
      v-if="!isEditMode && fields.promotionCode.value"
      class="copy-to-clipboard"
      :promotionCode="fields.promotionCode.value"
    />
    <div v-if="isEditMode">
      <sc-text class="external-url" :field="fields.externalUrl"/>
    </div>
    <sh-button
      v-if="!isEditMode && fields.externalUrl.value"
      tag="a"
      color="primary"
      role="link"
      size="medium"
      :href="fields.externalUrl.value" target="_blank" class="primary link-button"
      :aria-label="`${$t('PERKS_VISIT_SITE_CTA_EXTENDED')}`"
    >
      {{ $t('PERKS_VISIT_SITE_CTA') }}
    </sh-button>
    <p class="text text-line">{{ $t('PERKS_HOUSE_TEXT') }}</p>
    <p class="text date-container">
      {{ $t('PERKS_EXPIRES_ON') }}
      <date-formatter :timestamp="date" />
    </p>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-vue'
import CopyToClipboardButton from '~/components/copy-to-clipboard-button'
import get from '~/helpers/get'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'WhiteBoardWithButton',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    ScText: Text,
    ScLink: Link,
    ScRichText: RichText,
    CopyToClipboardButton
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    date () {
      return get(this.fields, ['validTo', 'value'])
    },

    // todo: for current code implementation until synchronization with venues
    convertName () {
      return get(this.fields, ['perksRegion', 'value']).replace(/ /g, '_').toUpperCase()
    },

    isCityWithoutHouse () {
      return get(this.fields, ['perksRegion', 'value']).toUpperCase()
        === this.$t('PERKS_VENUE_CITIES_WITHOUT_HOUSES')
    }
  }
}
</script>

<style lang="scss">

.white-board-container {
  padding: $d-med 0;
  text-align: center;

  @include tablet {
    padding: $space-080 0;
  }

  .title {
    @include font('090');

    font-weight: 600;
    color: $color-black;
    padding: 0;
    margin-top: 27px;
  }

  .description {
    @include font('060');

    color: $color_gray_3;
    margin: 29px 0 40px 0;
  }

  .text {
    @include font('030');

    text-transform: uppercase;
    padding: 0;
    margin: 0;
    color: $color_gray_2;
  }

  .link-button {
    @include font('020');

    padding: 11px 64px;
    margin-top: 24px;
  }

  .text-line {
    padding-top: $space-070;
    margin-top: $space-070;;
    border-top: $line-medium;
  }

  .date-container {
    margin-top: 16px;
  }

  .copy-to-clipboard {
    @include font('030');

    display: block;
    margin: 0 auto;
    border: none;
    background: transparent;
    cursor: pointer;
    font-stretch: normal;
    letter-spacing: normal;
    text-transform: capitalize;

    &.disabled {
      background: none;
    }

    &:not(.ghost):not(.primary):not(.grayscale) {
      box-shadow: none;

      &:hover:not([disabled]),
      &:focus:not([disabled]),
      &:active:not([disabled]) {
        box-shadow: none;
        background: transparent;
      }
    }
  }

  .promotion-code span,
  .external-url span {
    max-width: 100%;
  }
}
</style>
